export default __webpack_public_path__ + "assets/b363988fa1945f9f3a2b3946fb01c902.png";